module.exports = __webpack_public_path__ + "static/img/2819_phase_function_Paper_PointsHejduk_Prediction.f20b9dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2819_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BPkG
// module chunks = 0